import * as React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement("path", {
  d: "M10 17l5-5-5-5v10z"
}), 'ArrowRight');


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/esm/ArrowRight.js
// module id = 2113
// module chunks = 2